export default __webpack_public_path__ + "static/mentoring-modal-popup-image-6917bb93a877d1575cb9386177a44ec9.jpg";